import { get, set, del } from 'idb-keyval'

/**
 * WebIdbBackend — backend de binarios para WEB. El binario (base64 dataURL) vive en idb-keyval
 * con clave = image_ref. SQLite SOLO guarda la referencia (MOD-04). v1 ya usaba idb-keyval para
 * fotos offline (src/services/offline-images.js:122) — mismo store, re-implementacion limpia.
 *
 * Web es best-effort por SYNC-03 (el servidor es la red de seguridad de cero-perdida). idb-keyval
 * puede ser evictado por el navegador; no es durabilidad DURA (esa es solo nativa).
 *
 * Contrato de backend (compartido por los 3 backends):
 *   write(imageRef, base64DataUrl) -> Promise<string|null localPath>
 *   read(record)                   -> Promise<string|null base64>
 *   del(record)                    -> Promise<void>
 *
 * En web localPath = null (la clave de lectura es el image_ref, no una ruta de archivo).
 */
export const WebIdbBackend = {
  /**
   * Persiste el binario por image_ref. Devuelve localPath=null (web no usa rutas de archivo).
   * @param {string} imageRef
   * @param {string} base64DataUrl
   * @returns {Promise<null>}
   */
  async write (imageRef, base64DataUrl) {
    await set(imageRef, base64DataUrl)
    return null
  },

  /**
   * Lee el binario por record.image_ref.
   * @param {{ image_ref: string }} record
   * @returns {Promise<string|null>} base64 dataURL o null si no existe.
   */
  async read (record) {
    if (!record || !record.image_ref) return null
    const v = await get(record.image_ref)
    return v == null ? null : v
  },

  /**
   * Borra el binario por record.image_ref (idempotente: borrar lo inexistente es no-op).
   * @param {{ image_ref: string }} record
   * @returns {Promise<void>}
   */
  async del (record) {
    if (!record || !record.image_ref) return
    await del(record.image_ref)
  }
}
